import "jquery-validation";
// Quote Form
(function ($) {
  $(document).ready(function () {
    $("#quote").validate({
      ignore: "",
      rules: {
        coveramount: "required",
        coverterm: "required",
        day: {
          required: true,
          notEqualTo: "Day"
        },
        month: {
          required: true,
          notEqualTo: "Month"
        },
        year: {
          required: true,
          notEqualTo: "Year"
        },
        firstname: {
          required: true,
          nameUK: true
        },
        lastname: {
          required: true,
          nameUK: true
        },
        partnerfirstname: {
          required: true,
          nameUK: true
        },
        partnerlastname: {
          required: true,
          nameUK: true
        },
        emailaddress: {
          required: true,
          email: true
        },
        phonenumber: {
          required: true,
          phonesUK: true
        },
        postcode: {
          required: true,
          postcodeUK: true
        },
        quotesfor: "required",
        smoked: "required",
        coverfor: "required"
      },
      messages: {
        coveramount: "Please select an option",
        coverterm: "Please select an option",
        day: "Please select a day",
        month: "Please select a month",
        year: "Please select a year",
        firstname: "Please enter your first name",
        lastname: "Please enter your last name",
        postcode: "Please enter your postcode",
        partnerfirstname: "Please enter your partners first name",
        partnerlastname: "Please enter your partners last name",
        emailaddress: {
          required: "Please enter your email address",
          email: "Please enter a valid email address"
        },
        phonenumber: {
          required: "Please enter your phone number",
          phoneUS: "Please enter a valid US phone number"
        },
        quotesfor: "Please select an option",
        smoked: "Please select an option",
        coverfor: "Please select an option"
      },
      errorPlacement: function (error, element) {
        if (element.attr("name") == "quotesfor") {
          error.insertAfter("#quotesfor-pre-error");
        } else if (element.attr("name") == "coverfor") {
          error.insertAfter("#coverfor-pre-error");
        } else if (element.attr("name") == "smoked") {
          error.insertAfter("#smoked-pre-error");
        } else if (element.attr("name") == "dob_birthDay") {
          error.insertAfter(".birthdayPicker");
        } else {
          error.insertAfter(element);
        }
      },

      invalidHandler: function (event, validator) {
        var errors = validator.numberOfInvalids();
        if (errors) {
          var firstErrorElement = $(validator.errorList[0].element);
          $("html, body").animate(
            {
              scrollTop: firstErrorElement.offset().top - 100
            },
            1000
          );
        }
        return false; // Prevents form from submitting
      },

      submitHandler: function (form) {
        const firstname = $("#firstname").val();
        const lastname = $("#lastname").val();
        const email = $("#emailaddress").val();
        const phone = $("#phonenumber").val();
        const postcode = $("#postcode").val();
        const coveramount = $("#coveramount").val();
        const coverterm = $("#coverterm").val();
        const partnerfirstname = $("#partnerfirstname").val();
        const custDob = $("#dob").val();
        const coverfor = $('input[name="coverfor"]:checked').val();
        const mcid = $("#mcidInput").val();
        const keyword = $("#kwInput").val();

        localStorage.setItem("firstname", firstname);
        localStorage.setItem("lastname", lastname);
        localStorage.setItem("email", email);
        localStorage.setItem("phone", phone);
        localStorage.setItem("postcode", postcode);
        localStorage.setItem("coveramount", coveramount);
        localStorage.setItem("coverterm", coverterm);
        localStorage.setItem("partnerfirstname", partnerfirstname);
        localStorage.setItem("dob", custDob);

        // Redirect to the /thank-you/ page
        // window.location.href = "/results/";

        // Serialize the form data
        var formData = $(form).serialize();

        // // Before making the SOAP API call using AJAX
        // const oneHour = 60 * 60 * 1000; // milliseconds
        // const formSubmittedTimestamp = localStorage.getItem('formSubmittedTimestamp');

        // if (formSubmittedTimestamp && (Date.now() - parseInt(formSubmittedTimestamp) < oneHour)) {
        // 	// If the form was submitted less than an hour ago, just redirect to the thank you page
        // 	console.log('Duplicate');
        // 	window.location.href = "/results/";
        // 	return;
        // }

        // if (!localStorage.getItem('formSubmittedTimestamp')) {
        // 	// Set the current time as a timestamp
        // 	localStorage.setItem('formSubmittedTimestamp', Date.now().toString());
        // }

        // Make the SOAP API call using AJAX
        $.ajax({
          type: "POST",
          url: "/wp-content/themes/understrap-main/lib/api/ws-lunar-capture.php",
          data: formData,
          beforeSend: function () {
            // Disable the submit button and add the spinner
            $("#quote-submit")
              .prop("disabled", true)
              .html(
                '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Submitting...'
              );
          },
          success: function (response) {
            if (response.status === "1") {
              // Success - API request was successful
              console.log("API request successful!");
              console.log(response.message);
              $("form#quote").hide();
              $("#ty-message").fadeIn();
              $("#firstname-text").text(firstname);
              // Split formData into separate key-value pairs
              var formDataPairs = formData.split("&");

              // Push each key-value pair to dataLayer under event "formData"
              var formDataObject = {};
              formDataPairs.forEach(function (pair) {
                var keyValue = pair.split("=");
                var fieldName = decodeURIComponent(keyValue[0]);
                var fieldValue = decodeURIComponent(keyValue[1]);
                formDataObject[fieldName] = fieldValue;
              });
              dataLayer.push({
                event: "formData",
                formData: formDataObject
              });

              // Trigger PHP file to send email using cURL
              //   triggerSendEmailPHP(formData);

              // You can perform additional actions if needed
              // For example, redirect to a thank-you page
              // window.location.href = "/instant-callback/thank-you/";
            } else {
              // API request failed, handle the error
              alert("API request failed: " + response.message);
              console.log(response);
              //   triggerSendEmailPHP(formData);
            }
          },
          error: function (jqXHR, textStatus, errorThrown) {
            // Handle AJAX error here
            // console.error("AJAX error:", textStatus, errorThrown);
            var soapError = extractSoapError(jqXHR.responseText);
            // triggerSendEmailPHP(formData);

            if (soapError) {
              console.log("SOAP API error: " + soapError);
            } else {
              console.log("An error occurred while making the API request.");
            }
          },
          complete: function () {
            // Re-enable the submit button and remove the spinner
            $("#quote-submit").prop("disabled", false).html("Submit");
          }
        });

        // Function to trigger PHP file for sending email using cURL
        function triggerSendEmailPHP(formData) {
          $.ajax({
            type: "POST",
            url: "/wp-content/themes/understrap-main/lib/api/sendgrid-api.php", // Replace with the actual path to your PHP file
            data: formData,
            success: function (phpResponse) {
              //   console.log("PHP file triggered successfully!");
              //   console.log(phpResponse);
            },
            error: function (phpError) {
              console.error("Error triggering PHP file:", phpError);
            }
          });
        }

        function extractSoapError(responseText) {
          try {
            var xmlDoc = $.parseXML(responseText);
            var $xml = $(xmlDoc);
            var soapError = $xml.find("executeSoapResult").text();
            return soapError.trim();
          } catch (e) {
            return null; // If there was an error parsing the XML, return null
          }
        }
      }
    });
  });
})(jQuery);

// Pre capture form for online first journey
(function ($) {
  $(document).ready(function () {
    $("#online-precapture").validate({
      ignore: "",
      rules: {
        firstname: {
          required: true,
          nameUK: true
        },
        lastname: {
          required: true,
          nameUK: true
        },

        emailaddress: {
          required: true,
          email: true
        },
        phonenumber: {
          required: true,
          phonesUK: true
        }
      },
      messages: {
        firstname: "Please enter your first name",
        lastname: "Please enter your last name",

        emailaddress: {
          required: "Please enter your email address",
          email: "Please enter a valid email address"
        }
      },

      invalidHandler: function (event, validator) {
        var errors = validator.numberOfInvalids();
        if (errors) {
          var firstErrorElement = $(validator.errorList[0].element);
          $("html, body").animate(
            {
              scrollTop: firstErrorElement.offset().top - 100
            },
            1000
          );
        }
        return false; // Prevents form from submitting
      },

      submitHandler: function (form) {
        const firstname = $("#firstname").val();
        const lastname = $("#lastname").val();
        const email = $("#emailaddress").val();

        const coverfor = $('input[name="coverfor"]:checked').val();
        const mcid = $("#mcidInput").val();
        const keyword = $("#kwInput").val();
        var appId = "";

        localStorage.setItem("firstname", firstname);
        localStorage.setItem("lastname", lastname);
        localStorage.setItem("email", email);

        // Redirect to the /thank-you/ page
        // window.location.href = "/results/";

        // Serialize the form data
        var formData = $(form).serialize();

        // Make the SOAP API call using AJAX
        $.ajax({
          type: "POST",
          url: "/wp-content/themes/understrap-main/lib/api/ws-lunar-capture.php",
          data: formData,
          beforeSend: function () {
            // Disable the submit button and add the spinner
            $("#quote-submit")
              .prop("disabled", true)
              .html(
                '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Submitting...'
              );
          },
          success: function (response) {
            if (response.status === "1") {
              // Success - API request was successful
              console.log("API request successful!");
              console.log(response.message);

              // Split formData into separate key-value pairs
              var formDataPairs = formData.split("&");

              // Push each key-value pair to dataLayer under event "formData"
              var formDataObject = {};
              formDataPairs.forEach(function (pair) {
                var keyValue = pair.split("=");
                var fieldName = decodeURIComponent(keyValue[0]);
                var fieldValue = decodeURIComponent(keyValue[1]);
                formDataObject[fieldName] = fieldValue;
              });
              dataLayer.push({
                event: "formData",
                formData: formDataObject
              });
              var appId = response.soapNo;

              // You can perform additional actions if needed
              // For example, redirect to a thank-you page
              var getUrl = `https://help.coverdirect.com/chatbot/34621d31cabf215eabf30314fdf6cd59?forename=${firstname}&surname=${lastname}&reference=${appId}&email=${email}`;
              // Make the GET request to retrieve the cbtoken
              $.ajax({
                type: "GET",
                url: getUrl,
                success: function (getResponse) {
                  var jsonResponse = JSON.parse(getResponse);
                  var cbtoken = jsonResponse.cbtoken; // Extract the cbtoken

                  // Redirect to the new URL with the cbtoken
                  window.location.href = `https://help.coverdirect.com/factfinder/cb/${cbtoken}/started`;
                },
                error: function (xhr, status, error) {
                  // Handle the GET request error
                  console.log("GET request failed.");
                  console.log(status);
                  console.log(error);
                }
              });
            } else {
              // API request failed, handle the error
              console.log("Lunar API failed");
              console.log(response);
              var getUrl = `https://help.coverdirect.com/chatbot/34621d31cabf215eabf30314fdf6cd59?forename=${firstname}&surname=${lastname}&reference=${appId}&email=${email}`;
              // Make the GET request to retrieve the cbtoken
              $.ajax({
                type: "GET",
                url: getUrl,
                success: function (getResponse) {
                  var jsonResponse = JSON.parse(getResponse);
                  var cbtoken = jsonResponse.cbtoken; // Extract the cbtoken

                  // Redirect to the new URL with the cbtoken
                  window.location.href = `https://help.coverdirect.com/factfinder/cb/${cbtoken}/started`;
                },
                error: function (xhr, status, error) {
                  // Handle the GET request error
                  console.log("GET request failed.");
                  console.log(status);
                  console.log(error);
                }
              });
              //   triggerSendEmailPHP(formData);
            }
          },
          error: function (jqXHR, textStatus, errorThrown) {
            // Handle AJAX error here
            // console.error("AJAX error:", textStatus, errorThrown);
            var soapError = extractSoapError(jqXHR.responseText);
            // triggerSendEmailPHP(formData);

            if (soapError) {
              console.log("SOAP API error: " + soapError);
            } else {
              console.log("An error occurred while making the API request.");
            }
            // Construct the URL for the GET request
            var getUrl = `https://help.coverdirect.com/chatbot/34621d31cabf215eabf30314fdf6cd59?forename=${firstname}&surname=${lastname}&reference=${appId}&email=${email}`;
            // Make the GET request to retrieve the cbtoken
            $.ajax({
              type: "GET",
              url: getUrl,
              success: function (getResponse) {
                var jsonResponse = JSON.parse(getResponse);
                var cbtoken = jsonResponse.cbtoken; // Extract the cbtoken

                // Redirect to the new URL with the cbtoken
                window.location.href = `https://help.coverdirect.com/factfinder/cb/${cbtoken}/started`;
              },
              error: function (xhr, status, error) {
                // Handle the GET request error
                console.log("GET request failed.");
                console.log(status);
                console.log(error);
              }
            });
          },
          complete: function () {
            // Re-enable the submit button and remove the spinner
            $("#quote-submit").prop("disabled", false).html("Submit");
          }
        });

        // Function to trigger PHP file for sending email using cURL
        function triggerSendEmailPHP(formData) {
          $.ajax({
            type: "POST",
            url: "/wp-content/themes/understrap-main/lib/api/sendgrid-api.php", // Replace with the actual path to your PHP file
            data: formData,
            success: function (phpResponse) {
              //   console.log("PHP file triggered successfully!");
              //   console.log(phpResponse);
            },
            error: function (phpError) {
              console.error("Error triggering PHP file:", phpError);
            }
          });
        }

        function extractSoapError(responseText) {
          try {
            var xmlDoc = $.parseXML(responseText);
            var $xml = $(xmlDoc);
            var soapError = $xml.find("executeSoapResult").text();
            return soapError.trim();
          } catch (e) {
            return null; // If there was an error parsing the XML, return null
          }
        }
      }
    });
  });
})(jQuery);

// Validate Expanded

(function ($, window, undefinded) {
  ("use strict");

  // Custom validation method to check if the value is not equal to the specified option
  $.validator.addMethod(
    "notEqualTo",
    function (value, element, param) {
      return value !== param;
    },
    "Please select a valid option."
  );

  // nameUK (Lunar ready)
  $.validator.addMethod(
    "nameUK",
    function (value, element) {
      return this.optional(element) || /^[a-zA-Z '-]{0,50}$/.test(value);
    },
    "Please specify a valid name"
  );

  // EMAIL new - modified version - @domain.ext
  $.validator.addMethod(
    "email",
    function (value, element) {
      return (
        this.optional(element) ||
        /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,61}$/.test(
          value
        )
      );
    },
    "Please specify a valid email"
  );

  // UK landline phone - no spaces and symbols
  $.validator.addMethod(
    "phoneUK",
    function (phone_number, element) {
      phone_number = phone_number.replace(/\(|\)|\s|-/g, "");
      element.value = phone_number; // auto correct
      return (
        this.optional(element) ||
        (phone_number.length > 9 &&
          phone_number.match(
            /^(?:(?:(?:00|\+)44)|(?:\(?0))(?:\d{2}\)?\d{8}|\d{3}\)?\d{3}\d{3,4}|\d{4}\)?(?:\d{5}|\d{6})|\d{5}\)?\d{4,5})$/
          ))
      );
    },
    "Please specify a valid phone number"
  );

  // UK mobile phone - no spaces and symbols
  $.validator.addMethod(
    "mobileUK",
    function (phone_number, element) {
      phone_number = phone_number.replace(/\(|\)|\s|-/g, "");
      element.value = phone_number; // auto correct
      return (
        this.optional(element) ||
        (phone_number.length > 9 &&
          phone_number.match(/^(?:(?:(?:00|\+)44|0)7(?:[1345789]\d{2}|624)\d{6})$/) &&
          !phone_number.match(
            /^(?:(?:(?:00|\+)44|0)1\d{9,10}|(?:00|\+)44(?:116|117|118|121|131|141|151|161|171|181|191|203|207|208|211|213|215|216|217|218|221|222|223|226|227|228|231|232|233|234|235|239|241|242|243|245|246|247|248|251|252|253|255|256|258|259|261|262|263|264|266|267|268|269|271|272|273|274|276|279|281|282|283|284|285|289|292|293|294|295|296|299|300|301|302|303|304|305|307|310|311|312|313|314|315|316|317|318|320|321|322|323|324|325|326|327|328|329|330|331|332|333|334|335|336|337|338|339|340|341|342|343|345|346|347|348|349|350|351|352|353|354|355|356|357|358|359|360|361|362|363|364|365|366|367|368|369|370|371|372|373|374|375|376|377|378|379|380|381|382|383|384|385|386|387|388|389|390|391|392|393|394|395|396|397|398|399|401|402|403|404|405|406|407|408|409|410|411|412|413|414|415|416|417|418|419|420|421|422|423|424|425|426|427|428|429|430|431|432|433|434|435|436|437|438|439|440|441|442|443|444|445|446|447|448|449|450|451|452|453|454|455|456|457|458|459|460|461|462|463|464|465|466|467|468|469|470|471|472|473|474|475|476|477|478|479|480|481|482|483|484|485|486|487|488|489|490|491|492|493|494|495|496|497|498|499|500|501|502|503|504|505|506|507|508|509|510|511|512|513|514|515|516|517|518|519|520|521|522|523|524|525|526|527|528|529|530|531|532|533|534|535|536|537|538|539|540|541|542|543|544|545|546|547|548|549|550|551|552|553|554|555|556|557|558|559|560|561|562|563|564|565|566|567|568|569|570|571|572|573|574|575|576|577|578|579|580|581|582|583|584|585|586|587|588|589|590|591|592|593|594|595|596|597|598|599|600|601|602|603|604|605|606|607|608|609|610|611|612|613|614|615|616|617|618|619|620|621|623|625|626|627|628|629|630|631|632|633|634|635|636|637|638|639|640|641|642|643|644|645|646|647|648|649|650|651|652|653|654|655|656|657|658|659|660|661|662|663|664|665|666|667|668|669|670|671|672|673|674|675|676|677|678|679|680|681|682|683|684|685|686|687|688|689|690|691|692|693|694|695|696|697|698|699|700|701|702|703|704|705|706|707|708|709|710|711|712|713|714|715|716|717|718|719|720|721|722|723|724|725|726|727|728|729|730|731|732|733|734|735|736|737|738|739|740|741|742|743|744|745|746|747|748|749|750|751|752|753|754|755|756|757|758|759|760|761|762|763|764|765|766|767|768|769|770|771|772|773|774|775|776|777|778|779|780|781|782|783|784|785|786|787|788|789|790|791|792|793|794|795|796|797|798|799|800|801|802|803|804|805|806|807|808|809|810|811|812|813|814|815|816|817|818|819|820|821|822|823|824|825|826|827|828|829|830|831|832|833|834|835|836|837|838|839|840|841|842|843|844|845|846|847|848|849|850|851|852|853|854|855|856|857|858|859|860|861|862|863|864|865|866|867|868|869|870|871|872|873|874|875|876|877|878|879|880|881|882|883|884|885|886|887|888|889|890|891|892|893|894|895|896|897|898|899|900|901|902|903|904|905|906|907|908|909|910|911|912|913|914|915|916|917|918|919|920|921|922|923|924|925|926|927|928|929|930|931|932|933|934|935|936|937|938|939|940|941|942|943|944|945|946|947|948|949|950|951|952|953|954|955|956|957|958|959|960|961|962|963|964|965|966|967|968|969|970|971|972|973|974|975|976|977|978|979|980|981|982|983|984|985|986|987|988|989|990|991|992|993|994|995|996|997|998|999)\d{6})$/
          ))
      );
    },
    "Please specify a valid UK mobile number"
  );

  // UK mobile and landline  - no spaces and symbols
  // Accepting only 01-3 for landline or 07 for mobile to exclude many premium numbers
  $.validator.addMethod(
    "phonesUK",
    function (phone_number, element) {
      phone_number = phone_number.replace(/\(|\)|\s|-/g, "");
      element.value = phone_number; // auto correct
      return (
        this.optional(element) ||
        (phone_number.length > 9 &&
          phone_number.match(/^(?:(?:(?:00|\+)44|0)(?:1\d{8,9}|[23]\d{9}|7(?:[1345789]\d{8}|624\d{6})))$/))
      );
    },
    "Please specify a valid UK phone number"
  );

  // UK postcode
  // Does not match to UK Channel Islands that have their own postcodes (non standard UK)
  $.validator.addMethod(
    "postcodeUK",
    function (value, element) {
      return (
        this.optional(element) ||
        /^((([A-PR-UWYZ][0-9])|([A-PR-UWYZ][0-9][0-9])|([A-PR-UWYZ][A-HK-Y][0-9])|([A-PR-UWYZ][A-HK-Y][0-9][0-9])|([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRVWXY]))\s?([0-9][ABD-HJLNP-UW-Z]{2})|(GIR)\s?(0AA))$/i.test(
          value
        )
      );
    },
    "Please specify a valid UK postcode"
  );

  // Date dd/mm/yyyy (Lunar ready)
  // @example <input name="pippo" class="{dateITA:true}" />
  $.validator.addMethod(
    "dateITA",
    function (value, element) {
      var check = false,
        re = /^\d{1,2}\/\d{1,2}\/\d{4}$/,
        adata,
        gg,
        mm,
        aaaa,
        xdata;
      if (re.test(value)) {
        adata = value.split("/");
        gg = parseInt(adata[0], 10);
        mm = parseInt(adata[1], 10);
        aaaa = parseInt(adata[2], 10);
        xdata = new Date(Date.UTC(aaaa, mm - 1, gg, 12, 0, 0, 0));
        if (xdata.getUTCFullYear() === aaaa && xdata.getUTCMonth() === mm - 1 && xdata.getUTCDate() === gg) {
          check = true;
        } else {
          check = false;
        }
      } else {
        check = false;
      }
      var lunarCheck = /^((0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d)$/i.test(value);
      return this.optional(element) || (check && lunarCheck);
    },
    $.validator.messages.date
  );

  // Date yyyy-mm-dd (with Lunar check)
  // @example <input name="pippo" class="{dateDB:true}" />
  $.validator.addMethod(
    "dateDB",
    function (value, element) {
      var check = false,
        re = /^\d{4}[-]\d{1,2}[-]\d{1,2}$/,
        adata,
        aaaa,
        mm,
        gg,
        xdata;
      if (re.test(value)) {
        adata = value.split("-");
        gg = parseInt(adata[2], 10);
        mm = parseInt(adata[1], 10);
        aaaa = parseInt(adata[0], 10);
        xdata = new Date(Date.UTC(aaaa, mm - 1, gg, 12, 0, 0, 0));
        if (xdata.getUTCFullYear() === aaaa && xdata.getUTCMonth() === mm - 1 && xdata.getUTCDate() === gg) {
          check = true;
        } else {
          check = false;
        }
      } else {
        check = false;
      }
      var lunarCheck = /^((19|20)\d\d[-](0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01]))$/i.test(value);
      return this.optional(element) || (check && lunarCheck);
    },
    $.validator.messages.date
  );

  /*
   * Lets you say "at least X inputs that match selector Y must be filled."
   *
   * The end result is that neither of these inputs:
   *
   *	<input class="productinfo" name="partnumber">
   *	<input class="productinfo" name="description">
   *
   *	...will validate unless at least one of them is filled.
   *
   * partnumber:	{require_from_group: [1,".productinfo"]},
   * description: {require_from_group: [1,".productinfo"]}
   *
   * options[0]: number of fields that must be filled in the group
   * options[1]: CSS selector that defines the group of conditionally required fields
   */
  $.validator.addMethod(
    "require_from_group",
    function (value, element, options) {
      var $fields = $(options[1], element.form),
        $fieldsFirst = $fields.eq(0),
        validator = $fieldsFirst.data("valid_req_grp") ? $fieldsFirst.data("valid_req_grp") : $.extend({}, this),
        isValid =
          $fields.filter(function () {
            return validator.elementValue(this);
          }).length >= options[0];

      // Store the cloned validator for future validation
      $fieldsFirst.data("valid_req_grp", validator);

      // If element isn't being validated, run each require_from_group field's validation rules
      if (!$(element).data("being_validated")) {
        $fields.data("being_validated", true);
        $fields.each(function () {
          validator.element(this);
        });
        $fields.data("being_validated", false);
      }
      return isValid;
    },
    $.validator.format("Please fill at least {0} of these fields.")
  );

  $.validator.addMethod(
    "noSpace",
    function (value, element) {
      return value.indexOf(" ") < 0 && value !== "";
    },
    "Please don't type any spaces"
  );

  $.validator.addMethod(
    "textonly",
    function (value, element) {
      return this.optional(element) || /^[a-z '-]+$/i.test(value);
    },
    "Please type text only - no numbers or symbols allow"
  );
})(window.jQuery || window.Zepto, window);
